import React from 'react';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import { formatCurrency, useLocale } from '@unisporkal/localization';
import styles from './Price.module.scss';

interface PriceProps {
  amount: number;
  currencyCode?: string;
}

const Price = ({ amount, currencyCode = 'USD' }: PriceProps) => {
  const locale = useLocale();
  const formatted = formatCurrency(amount, locale, currencyCode);

  return (
    <Typography
      data-testid="price"
      variant={TypographyVariant.body.medium}
      component={TypographyComponentEnum.SPAN}
      className={styles.price}
    >
      {formatted.formattedPrice}
    </Typography>
  );
};

export default Price;
